import moment from 'moment'

import { RangeValues, startOfDayUTC, endOfDayUTC, isDateFuture } from '../util/datetime'

import { MomentDatePicker } from './DatePicker'
import { DatePickerContainer } from './DatePickerContainer'
import { ConfigProvider } from 'antd'

type DateRange = 'future'

type Props = {
  disabled?: boolean
  label?: string
  errorMessage?: string
  onChange: (dates: RangeValues) => void
  value?: RangeValues
  className?: string
  placeholderFrom?: string
  placeholderTo?: string
  disableDateRange?: DateRange
  allowClear?: boolean
  allowEmpty?: [boolean, boolean]
}

const rangeComparisons: Record<DateRange, (date: Date) => boolean> = {
  future: isDateFuture,
} as const

export const DateRangePicker = (props: Props): JSX.Element => {
  const {
    disabled,
    label,
    errorMessage,
    value,
    className,
    placeholderFrom,
    placeholderTo,
    disableDateRange,
    onChange,
    allowClear,
    allowEmpty,
  } = props

  const startMoment = value?.start ? moment(value.start) : null
  const endMoment = value?.end ? moment(value.end) : null

  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            activeBorderColor: 'rgba(var(--m-color-primary-60, 0, 84, 84), 1)',
            cellActiveWithRangeBg: 'rgba(var(--m-color-primary-60, 0, 84, 84), 0.1)',
            cellRangeBorderColor: 'rgba(var(--m-color-primary-60, 0, 84, 84), 0.1)',
          },
        },
        token: {
          colorPrimary: 'rgba(var(--m-color-primary-60, 0, 84, 84), 1)',
        },
      }}
    >
      <DatePickerContainer
        errorMessage={errorMessage}
        disabled={Boolean(disabled)}
        label={label}
        className={className}
      >
        <MomentDatePicker.RangePicker
          placeholder={[placeholderFrom || 'From', placeholderTo || 'To']}
          disabled={Boolean(disabled)}
          disabledDate={
            disableDateRange
              ? (momentDate) => rangeComparisons[disableDateRange](momentDate.toDate())
              : undefined
          }
          allowClear={allowClear}
          allowEmpty={allowEmpty}
          value={[startMoment, endMoment]}
          onChange={(values) => {
            const isoDates: RangeValues = {}
            values?.forEach((nextValue, index) => {
              if (index === 0 && nextValue) {
                isoDates.start = startOfDayUTC(nextValue.toDate())
                return
              }
              if (index === 1 && nextValue) {
                isoDates.end = endOfDayUTC(nextValue.toDate())
              }
            })
            onChange(isoDates)
          }}
        />
      </DatePickerContainer>
    </ConfigProvider>
  )
}
